//CustomNodeComponent.tsx

import React, { useState } from 'react';
import { Handle, Position } from 'reactflow';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import Typography from '@mui/material/Typography';


interface InputOutputCommon {
    UnitName: string;
    FlowType: string;
    AmountValue: number;
}

interface Input extends InputOutputCommon {
    InputFlowID: { low: number; high: number };
    InputFlowName: string;
    DefaultProvider: { low: number; high: number };
    DefaultProviderLocation: string;
    DefaultProviderName: string;
}

interface Output extends InputOutputCommon {
    OutputFlowID: { low: number; high: number };
    OutputFlowName: string;
}


interface Output extends InputOutputCommon {
    OutputFlowID: { low: number; high: number };
    OutputFlowName: string;
}

interface CustomNodeData {
    inputs: Input[];
    label: string;
    title: string;
    isParent: boolean; // Add a new property to indicate if this is a parent node
    value: number; // Add a new property to store the input value
    updateValue: (value: number) => void; // Add a new function to update the value
}

// Define a new interface for your component's props that includes both the data and the onPlusClick function
interface CustomNodeComponentProps {
    data: CustomNodeData;
}

const CustomNodeComponent: React.FC<CustomNodeComponentProps> = ({ data }) => {
    const [inputValue, setInputValue] = useState('');
    const [calculatedValue, setCalculatedValue] = useState(0);

    const handleInputChange = (event: React.ChangeEvent<HTMLInputElement>, amountValue: number) => {
        const newInputValue = event.target.value;
        if (!isNaN(Number(newInputValue))) {
            setInputValue(newInputValue);
            setCalculatedValue(Number(newInputValue) * amountValue);
        }
    };
    return (
        <div>
            <Handle type="target" position={Position.Left} style={{ borderRadius: 0 }} />
            {data.isParent ? (
                <Typography variant="h6" style={{ color: 'Black', padding: '10px' }}>
                    {data.title}
                </Typography>
            ) : null}
            <TableContainer component={Paper} style={{ width: 'auto', backgroundColor: '#f0f0f0' }}>

                <Table size="small" aria-label="custom node table" style={{ tableLayout: 'fixed' }}>
                    {data.isParent ? ( // Render the table headers if this is a parent node

                        <TableHead>
                            <TableRow>
                                <TableCell style={{ width: '2%', maxWidth: '2%', backgroundColor: 'black', color: 'white', borderRight: '1px solid white' }}>ID</TableCell>
                                <TableCell style={{ width: '10%', maxWidth: '10%', backgroundColor: 'black', color: 'white', borderRight: '1px solid white' }}>Input</TableCell>
                                <TableCell style={{ width: '10%', maxWidth: '10%', backgroundColor: 'black', color: 'white', borderRight: '1px solid white' }}>Location</TableCell>
                                <TableCell style={{ width: '5%', maxWidth: '5%', backgroundColor: 'black', color: 'white', borderRight: '1px solid white' }}>Provider ID</TableCell>
                                <TableCell style={{ width: '10%', maxWidth: '10%', backgroundColor: 'black', color: 'white', borderRight: '1px solid white' }}>Amount</TableCell>
                                <TableCell style={{ width: '2%', maxWidth: '2%', backgroundColor: 'black', color: 'white', borderRight: '1px solid white' }}>Unit</TableCell>
                                <TableCell style={{ width: '5%', maxWidth: '5%', backgroundColor: 'black', color: 'white', borderRight: '1px solid white' }}>Price</TableCell>
                                <TableCell style={{ width: '5%', maxWidth: '5%', backgroundColor: 'black', color: 'white', borderRight: '1px solid white' }}>Total Cost</TableCell>
                            </TableRow>
                        </TableHead>
                    ) : ( // Render the table rows if this is a child node
                        <TableBody>


                            {data.inputs && data.inputs.map((input: Input, index: number) => ( // Check if inputs is defined before calling .map()
                                <TableRow key={index}>
                                    <TableCell style={{ width: '2%', maxWidth: '2%', borderRight: '1px solid black' }}>{input.InputFlowID.low}</TableCell>
                                    <TableCell style={{ width: '10%', maxWidth: '10%', borderRight: '1px solid black' }}>{input.InputFlowName}</TableCell>
                                    <TableCell style={{ width: '10%', maxWidth: '10%', borderRight: '1px solid black' }}>{input.DefaultProviderLocation}</TableCell>
                                    <TableCell style={{ width: '5%', maxWidth: '5%', borderRight: '1px solid black' }}>{input.DefaultProvider.low}</TableCell>
                                    <TableCell style={{ width: '10%', maxWidth: '10%', borderRight: '1px solid black', textAlign: 'right' }}>{input.AmountValue}</TableCell>
                                    <TableCell style={{ width: '2%', maxWidth: '2%', borderRight: '1px solid black' }}>{input.UnitName}</TableCell>
                                    <TableCell style={{ width: '5%', maxWidth: '5%', borderRight: '1px solid black', textAlign: 'right' }}>
                                    <input type="number" value={inputValue} onChange={(event) => handleInputChange(event, input.AmountValue)} />
                                    </TableCell>
                                    <TableCell style={{ width: '5%', maxWidth: '5%', borderRight: '1px solid black', textAlign: 'right' }}>
                                        ${calculatedValue.toFixed(2)}
                                    </TableCell>

                                </TableRow>
                            ))}
                        </TableBody>
                    )}
                </Table>
            </TableContainer>
            <Handle type="source" position={Position.Right} style={{ borderRadius: 0 }} />
        </div>
    );
};

export default CustomNodeComponent;